import { inject, Injectable } from '@angular/core';
import { BaseLogging } from '@rx-applications/shared/logging';
import { EventName, LogChannelMessageMappings } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class AuthLoggerService {
  #loggingService = inject(BaseLogging);

  clickedOnReset(): void {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.ClickedOnReset];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, messageAndChannelMapping.message);
  }

  landedOnLoginScreen(props: { Company: string }): void {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.LandedOnLoginScreen];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, { ...messageAndChannelMapping.message, props });
  }

  loginSuccess(props: Record<string, unknown>) {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.LoginSuccess];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, { ...messageAndChannelMapping.message, props });
  }

  loginFailed(props: Record<string, unknown>) {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.LoginSuccess];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, { ...messageAndChannelMapping.message, props });
  }

  endSession() {
    this.#loggingService.createSetup({ endSession: true });
  }

  setProperties(loggingPropertyConfiguration: { isImpersonated: boolean }) {
    this.#loggingService.createSetup(loggingPropertyConfiguration);
  }

  forceChangePassword(props: { email: string }): void {
    const messageAndChannelMapping = LogChannelMessageMappings[EventName.ForceChangePassword];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, { ...messageAndChannelMapping.message, props });
  }
}
